import React from 'react';
import PropTypes from 'prop-types';
import { t } from '../../../../services/i18nService';
import { getA11yAttributesV2 } from '../../../../services/a11yIIBScreenReaderService';

import styles from '../../testOverview.scss';

/**
 * Component displayed when webcam diagnosis has failed
 */
const WebcamDiagnosisFailed = ({ onRetry }) => (
    <div
        className={styles.webcamHealthCheckFailedCustom}
        {...getA11yAttributesV2({
            role: 'alert',
            tabIndex: 0,
        })}
    >
        <div className={styles.webcamHealthCheckFailedGrid}>
            <div className={styles.webcamHealthCheckFailedIconCol}>
                <i
                    className={`fa fa-exclamation-circle ${styles.webcamHealthCheckFailedIcon}`}
                    aria-hidden="true"
                />
            </div>
            <div className={styles.webcamHealthCheckFailedTextCol}>
                <span className={styles.webcamHealthCheckFailedTitle}>
                    {t('hardwareAccessCheck.webCamWarning.lowLightingDetectedHeading')}
                </span>
            </div>
            <div className={styles.webcamHealthCheckFailedButtonCol}>
                <button
                    className={styles.webcamHealthCheckFailedRetry}
                    onClick={onRetry}
                    {...getA11yAttributesV2({
                        'aria-label': t('hardwareAccessCheck.retryMicHealthCheck'),
                    })}
                >
                    {t('hardwareAccessCheck.retryMicHealthCheck')}
                </button>
            </div>
            <div className={styles.webcamHealthCheckFailedMessage}>
                {t('hardwareAccessCheck.webCamWarning.lowLightingDetectedMessage')}
            </div>
        </div>
    </div>
);

WebcamDiagnosisFailed.propTypes = {
    onRetry: PropTypes.func.isRequired,
};

export default WebcamDiagnosisFailed;
